var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-popover',{ref:"popover",attrs:{"target":_vm.target,"title":_vm.title,"trigger":_vm.trigger,"auto-placement":false,"placement":"bottom"},on:{"show":_vm.onShow,"hide":_vm.onHide},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_c('template',{slot:"popover"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4675b816","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown-box/DropdownBox.vue
// module id = null
// module chunks = 